var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"dashboard","tag":"section","fluid":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":"20","indeterminate":"","color":"rgba(0, 0, 0, 0.87)"}}):_c(_vm.userDashboard,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }